import capitalize from 'lodash/capitalize';

/**
 *
 * @param onClickHandler
 */
export default function getGroupCellRenderer(onClickHandler) {
  /**
   *
   */
  function GroupCellRenderer() {}

  GroupCellRenderer.prototype.init = function ({ data, node }) {
    const cellDiv = document.createElement('div');
    const span = document.createElement('span');
    span.innerHTML = capitalize(data.sku);
    cellDiv.appendChild(span);

    if (node.group && node.data.hasMaxVariants && node.expanded) {
      const button = document.createElement('button');
      button.onclick = function (e) {
        e.stopPropagation();
        onClickHandler(e.target.value);
      };
      button.textContent = 'View All';
      button.setAttribute('value', node.data.legacyProductsId);
      button.setAttribute('class', 'group-button');
      cellDiv.appendChild(button);
    }

    this.eGui = cellDiv;
  };

  GroupCellRenderer.prototype.getGui = function () {
    return this.eGui;
  };

  return GroupCellRenderer;
}
